const alertPropsData = [
  {
    property: 'handleCloseAlert',
    type: 'Func',
    required: 'true',
    default: '--',
    description: 'Is called when X button is clicked. Control hiding of alert in the parent.',
  },
  {
    property: 'message',
    type: 'String',
    required: 'true',
    default: '--',
    description: 'Message to display.',
  },
  {
    property: 'type',
    type: 'String',
    required: 'true',
    default: '--',
    description: 'Can be "success" or "failure". Displays as green or red.',
  },
];

const tablePropsData = [
  {
    property: 'headers',
    type: 'Array of strings',
    required: 'true',
    default: '--',
    description: 'Populates the headers of table.',
  },
  {
    property: 'data',
    type: 'Array of objects',
    required: 'true',
    default: '--',
    description: 'Populates the data rows of the table. Object keys map to headers.',
  },
  {
    property: 'fancy',
    type: 'Bool',
    required: 'false',
    default: 'false',
    description: 'Produces a fancy table.',
  },
];

const flyerPropsData = [
  {
    property: 'id',
    type: 'string',
    required: 'false',
    default: '""',
    description: 'Adds an id to the flyout.',
  },
  {
    property: 'title',
    type: 'string',
    required: 'true',
    default: '--',
    description: 'Displays title at the top of the flyout.',
  },
]

export { alertPropsData, tablePropsData, flyerPropsData };
